/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryOutQuery } from '../../models/get-inventory-out-query';
import { GetInventoryOutQueryResult } from '../../models/get-inventory-out-query-result';

export interface ApiNurseryManagerInventoryOutGetInventoryOutPost$Params {
      body?: GetInventoryOutQuery
}

export function apiNurseryManagerInventoryOutGetInventoryOutPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryOutGetInventoryOutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryOutGetInventoryOutPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryOutQueryResult>;
    })
  );
}

apiNurseryManagerInventoryOutGetInventoryOutPost.PATH = '/api/NurseryManager/InventoryOut/GetInventoryOut';
